module.exports = __webpack_public_path__ + "img/gd.67cf8359.svg";